import { render, staticRenderFns } from "./scroll-panel.vue?vue&type=template&id=a1e405d6&scoped=true&lang=pug&"
import script from "./scroll-panel.vue?vue&type=script&lang=js&"
export * from "./scroll-panel.vue?vue&type=script&lang=js&"
import style0 from "./scroll-panel.vue?vue&type=style&index=0&id=a1e405d6&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e405d6",
  null
  
)

export default component.exports